namespace Solovis.InvDataSelectors {

    export class ManagerSelectorControl extends Solovis.UI.BaseControl {

        public selectionCallback;
        public cancelCallback;

        private _portalServices: Solovis.Portal.IPortalServices;

        public searchBox: JQuery;


        constructor(options) {
            super(options);

            this._portalServices = options.portalServices;

            this.selectionCallback = options.selectionCallback ? options.selectionCallback : null;
            this.cancelCallback = options.cancelCallback ? options.cancelCallback : null;
        }

        public doInit() {
        }

        public doRender() {
            var self = this;

            var itemsToDisplay = 10;
            var moreResultsToDisplay = 500;

            let findItems = (autocompleteRequest, responseCallback) => {

                var filterText = autocompleteRequest.term;

                this._portalServices.rpc().invoke("~/Selectors/ManagerSelector/FindManager", { filterText: filterText, maxItems: itemsToDisplay },
                    function (response, success) {
                        if (success) {
                            var result = response.result;
                            var data = result.data;

                            if (result.hasMoreData) {
                                data.splice(itemsToDisplay, 1, { showMoreResults: true, filterText: filterText });
                            }
                            responseCallback(data);
                        }
                        else {
                            // TODO: report error somehow
                            responseCallback([]);
                        }
                    });
            }

            this.searchBox = $("<input>").attr("type", "text").appendTo(this.container);

            (this.searchBox as any).autocomplete({
                minLength: 1,
                source: findItems,
                focus: function (event, ui) {
                    if (ui.item)
                        self.searchBox.val(ui.item.name);
                    return false;
                },
                select: (event, ui) => {
                    if (ui.item) {
                        if (ui.item.showMoreResults) {
                            this._portalServices.rpc().invoke("~/Selectors/ManagerSelector/FindManager", { filterText: ui.item.filterText, includeAll: true },
                                function (response, success) {
                                    if (success) {
                                        var data = response.result.data;

                                        // Transform the data to include 'label' property for StringFilterListDialog
                                        var transformedData = data.map(function(manager) {
                                            return {
                                                ...manager,
                                                label: manager.name,  // Add label property for StringFilterListDialog
                                                item: manager         // Keep original manager data accessible
                                            };
                                        });

                                        Solovis.UI.Dialogs.StringFilterListDialog.showDialog({
                                            title: "Select Manager",
                                            selectCallback: function (selectedItem) {
                                                if (self.selectionCallback) {
                                                    // Pass the original manager data, not the transformed data
                                                    self.selectionCallback(selectedItem.item);
                                                }
                                            },
                                            stringFilterListControlOptions: {
                                                listItems: transformedData,
                                                itemDivGenerator: function (itemHolder, filterOptions) {
                                                    var itemDiv = $("<div>").text(itemHolder.item.name);
                                                    // TODO: Add manager icon if/when available
                                                    // itemDiv.prepend(Solovis.UI.Icons.createManagerIcon({ "padding-right": "10px" }));
                                                    return itemDiv;
                                                }
                                            }
                                        });
                                    }
                                    else {
                                        // TODO: report error somehow
                                    }
                                });
                        }
                        else {
                            self.searchBox.val(ui.item.name);
                            var item = ui.item;

                            if (self.selectionCallback) {
                                self.selectionCallback(item);
                            }
                        }
                    }
                    return false;
                },
                search: function (event, ui) {
                    // NOTE: spinners are built into the control
                    this.waitImageDiv = Solovis.UI.StockAnimations.createSpinningCircles({
                        diameter: "20px",
                        top: $(this).position().top + 20,
                        left: $(this).width() + 5
                    })
                        .insertAfter(this);
                },
                response: function (event, ui) {
                    if (this.waitImageDiv) {
                        this.waitImageDiv.remove();
                    }
                }

            })
                .data("ui-autocomplete")._renderItem = function (ul, item) {
                    var itemLink = $("<a>");
                    var itemElement = $("<li>");

                    if (item.showMoreResults) {
                        itemLink.append(Solovis.UI.Icons.createMoreResultsIcon({ "padding-right": "10px" }))
                            .append(
                            $("<strong>").text("Show More Results")
                            );
                    }

                    else {
                        var name = item.name;
                        itemLink.text(name);

                        // TODO: Add manager icon if available
                        // Solovis.UI.Icons.createManagerIcon({ "padding-right": "10px" })
                        //     .prependTo(itemLink);
                    }

                    itemElement.append(itemLink);
                    itemElement.appendTo(ul);
                    return itemElement;
                };

            // Trigger cancel when escape is pressed.
            $(this.searchBox).keyup(function (e) {
                if (e.keyCode == 27) {
                    // Escape was pressed.
                    if (self.cancelCallback) {
                        self.cancelCallback();
                    }
                }
            });
        }

        public focus() {
            if (this.searchBox) {
                this.searchBox.focus();
            }
        }

    }

}